export const routeIndexGroupNames = { VISITOR: 'GetStarted', AUTH: 'Home' };
